import React from "react";
import { Text } from "@chakra-ui/react";

const smallUppercaseWithletterSpace = {
  fontWeight: "800",
  fontSize: "8px",
  lineHeight: "16px",
  color: "#0E3665",
  fontFamily: "Nunito",
  textTransform: "uppercase",
  letterSpacing: "2px",
};

const SubHeading = ({ subHeadingLabel, ...props }) => {
  return (
    <Text {...smallUppercaseWithletterSpace} {...props}>
      {subHeadingLabel}
    </Text>
  );
};

export default SubHeading;
